<template>
    <div class="container">
      <b-card tag="article" class="mb-2">
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
              <label
                  for="pntesta"
                  class="h5"
              >Seleziona files: PNTESTA.TXT</label>
                <ejs-uploader ref="pntesta" id='pntesta' name="pntesta" :asyncSettings= "path"
                              :removing="addJWTHeaders" :autoUpload="false"
                              :uploading="onFileUpload" :success="afterUploadTesta"
                              :selected="onSelectTesta"
                ></ejs-uploader>
            </div>
            <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
              <label
                  for="pnrigcon"
                  class="h5"
              >Seleziona files: PNRIGCON.TXT</label>
              <ejs-uploader ref="pnrigcon" id='pnrigcon' name="pnrigcon" :asyncSettings= "path"
                            :removing="addJWTHeaders" :autoUpload="false"
                            :uploading="onFileUpload" :success="afterUpload"
                            :selected="onSelectRigcon"
                            :enabled="buttonState"
              ></ejs-uploader>
            </div>
            <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
              <label
                  for="pnrigiva"
                  class="h5"
              >Seleziona files: PNRIGIVA.TXT</label>
              <ejs-uploader ref="pnrigiva" id='pnrigiva' name="pnrigiva" :asyncSettings= "path"
                            :removing="addJWTHeaders" :autoUpload="false"
                            :uploading="onFileUpload" :success="afterUpload"
                            :selected="onSelectIva"
                            :enabled="buttonState"
              ></ejs-uploader>
            </div>
<!--            <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12 mt-1 text-right">-->
<!--              <ejs-button-->
<!--                  id="carica"-->
<!--                  ref="carica"-->
<!--                  cssClass="e-flat"-->
<!--                  :disabled="buttonState"-->
<!--                  @click.native="uploadAll()"-->
<!--              >Genera-->
<!--              </ejs-button>-->
<!--            </div>-->
        </div>
      </b-card>
    </div>
</template>
<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'

// import { createElement, isNullOrUndefined, detach, EventHandler } from '@syncfusion/ej2-base';

import { CardPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons'
import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs'
import { createElement } from '@syncfusion/ej2-base'

const uploadEle = createElement('span', { className: 'prova' })
uploadEle.innerHTML = ' '
const clearEle = createElement('span', { className: 'remove e-icons' })
clearEle.innerHTML = 'Clear All'
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(UploaderPlugin)

export default {
  data() {
    return {
      d: [],
      buttonState: false,
      path: {
        saveUrl: `${process.env.VUE_APP_API_ENDPOINT}/demo/api/pnrigcon/importa`,
        removeUrl: `${process.env.VUE_APP_API_ENDPOINT}/demo/api/pnrigcon/remove`,
      },
      buttons: {
        browse: 'Choose file',
        clear: clearEle,
        upload: uploadEle,
      },
    }
  },
  methods: {
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },
    addJWTHeaders(args) {
      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', 'Bearer ' + token)
    },
    onFileUpload(args) {
      console.log("FILEDATA")
      console.log(args.fileData)

      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', 'Bearer ' + token)
    },
    afterUpload(args) {
      // console.log(args)
      if (args.name === 'success') {
        // console.log('tutto a posto')
        // TODO: Inserire notifica successo
        // this.$router.push('/')
        this.makeToast('primary', 'Info', 'Import eseguito correttamente')
      }
    },
    afterUploadTesta(args) {
      console.log("aaaaaa")
      console.log(args)
      if (args.name === 'success') {
        // console.log('tutto a posto')
        // TODO: Inserire notifica successo
        // this.$router.push('/')
        this.makeToast('primary', 'Info', 'Import eseguito correttamente')
        this.buttonState = true
      }
    },
    onSelectTesta(args) {
      const fileRichiesto = 'PNTESTA.TXT'
      // const fileRichiesti = ['PNTESTA.TXT', 'PNRIGIVA.TXT', 'PNRIGCON.TXT']
      const nomiFile = []
      // const dati = this.$refs.pnfiles.getFilesData()
      args.filesData.forEach(item => {
        nomiFile.push(item.name)
      })

      // todo disable upload
      // const containAll = nomiFile.includes(fileRichiesto)

      // // disabilitare e nascondere tasto upload-all
      // if (containAll) {
      //   this.buttonState = false
      // }
      // console.log(containAll)
    },
    onSelectRigcon(args) {
      // const fileRichiesti = ['PNTESTA.TXT', 'PNRIGIVA.TXT', 'PNRIGCON.TXT']
      // const nomiFile = []
      // // const dati = this.$refs.pnfiles.getFilesData()
      // args.filesData.forEach(item => {
      //   nomiFile.push(item.name)
      // })
      //
      // const containAll = fileRichiesti.every(item => {
      //   return nomiFile.includes(item)
      // })
      //
      // // disabilitare e nascondere tasto upload-all
      // if (containAll) {
      //   this.buttonState = false
      // }
      // console.log(containAll)
    },
    onSelectIva(args) {
      // const fileRichiesti = ['PNTESTA.TXT', 'PNRIGIVA.TXT', 'PNRIGCON.TXT']
      // const nomiFile = []
      // // const dati = this.$refs.pnfiles.getFilesData()
      // args.filesData.forEach(item => {
      //   nomiFile.push(item.name)
      // })
      //
      // const containAll = fileRichiesti.every(item => {
      //   return nomiFile.includes(item)
      // })
      //
      // // disabilitare e nascondere tasto upload-all
      // if (containAll) {
      //   this.buttonState = false
      // }
      // console.log(containAll)
    },
    uploadAll() {
      console.log('carica tutto')
      this.$refs.pnfiles.upload()
    },
  },
}
</script>
<style>
@import "~@syncfusion/ej2-base/styles/bootstrap.css";
@import "~@syncfusion/ej2-buttons/styles/bootstrap.css";
@import "~@syncfusion/ej2-vue-inputs/styles/bootstrap.css";
.control-section {
  height: 100%;
  min-height: 200px;
}

button:has(> span.prova)
{
  display: none;
}
</style>
